import React, { useEffect, useState } from 'react';
import SimpleBarChart from './charts/SimpleBarChart';
import sourceColors from '../sourceColors.json';
import { getDisplayName } from '../sourceDisplayNames';

const SOURCES = [
  '2Seam',
  '4SeamLower',
  '4SeamA',
  '4SeamUpper',
  'MixedOversize',
  'Rewash Coal',
];

function ProductCVBarChart({ start, end }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!start || !end) return;
    const srcParam = SOURCES.map(encodeURIComponent).join(',');
    fetch(`/api/dms-product-cv-sum.php?start=${start}&end=${end}&sources=${srcParam}`)
      .then(res => res.json())
      .then(res => {
        const parsed = SOURCES.map(src => ({
          label: getDisplayName(src),
          value: parseFloat(res[src]) || 0,
          color: sourceColors[src] || '#22c55e',
          display: (parseFloat(res[src]) || 0).toFixed(2),
          valueInside: true,
        })).filter(d => d.value > 0);
        setData(parsed);
      })
      .catch(() => setData([]));
  }, [start, end]);

  if (data.length === 0) {
    return <div className="flex-1 flex items-center justify-center text-sm">No data</div>;
  }

  const calcStep = val => {
    if (val === 0) return 1;
    const rough = val / 5;
    const pow = Math.pow(10, Math.floor(Math.log10(rough)));
    const mults = [1, 2, 5, 10];
    for (const m of mults) {
      if (rough <= m * pow) return m * pow;
    }
    return 10 * pow;
  };

  const maxVal = Math.max(...data.map(d => d.value), 0);
  const step = calcStep(maxVal);
  const tickCount = Math.ceil(maxVal / step);
  const ticks = Array.from({ length: tickCount + 1 }, (_, i) => +(i * step).toFixed(2));
  const maxAxis = tickCount > 0 ? ticks[ticks.length - 1] : step;

  return (
    <SimpleBarChart
      key={`${start}-${end}-${data.length}`}
      height={160}
      data={data}
      max={maxAxis}
      ticks={ticks}
      valueClass="text-sm font-bold"
      labelFontSize={14}
      labelBold
    />
  );
}

export default ProductCVBarChart;
